import {
  ALERT_ERROR, DELETE, FETCH_MIXTURES, FETCH_RAW_MATERIALS, FULFILLED, LOGOUT, RAW_MATERIAL, REJECTED
} from 'actionTypes';
import cloneDeep from 'lodash/cloneDeep';
import { RAW_MATERIALS, toApiPayload } from 'utils/import/columns';
import { fork, put, select, takeLatest } from 'redux-saga/effects';
import actionsFactory from 'utils/redux/baseEntitiesFactory/actions';
import reducerFactory from 'utils/redux/baseEntitiesFactory/reducer';
import sagasFactory from 'utils/redux/baseEntitiesFactory/sagas';
import thunkFactory from 'utils/redux/baseEntitiesFactory/thunk';
import options from 'utils/redux/reducingOptions/rawMaterials';
import { apiRequest } from 'utils/request';
import { handlerError as sagaErrorHandler } from 'utils/sagasHelpers';


/** Actions -----------------------------------  **/

const handleError = (TYPE, error, dispatch) => {
  console.log('handle error rawMaterials helpers: ', error.response);
  if (error.response) {
    if (error.response.status === 401) {
      dispatch({ type: ALERT_ERROR, payload: error.response.data.detail });
      dispatch({ type: 'LOGOUT' });
    } else {
      dispatch({ type: TYPE + REJECTED, payload: error.response.statusText });
      dispatch({ type: ALERT_ERROR, payload: error.response.statusText });
    }
  } else {
    dispatch({ type: TYPE + REJECTED, payload: 'Unknown error' });
    dispatch({ type: ALERT_ERROR, payload: 'Unknown error' });
  }
};

const importRawMaterialsMultiple = data => dispatch => {
  let submitData = cloneDeep(data);
  submitData = submitData.map(row => {
    row.cas = JSON.stringify(row.cas);
    row.ec = JSON.stringify(row.ec);
    return row;
  });
  // The spreadsheet's column names become the API's here and nowhere else, so
  // the file keeps its own contract when the fields are renamed again.
  submitData = toApiPayload(submitData, RAW_MATERIALS.translateFileHeadersToApiFields);
  return apiRequest('/raw_materials/batch_import/', 'POST', submitData)
    .then(response => {
      // Insertion on DB takes a while so the FETCH is delayed
      setTimeout(() => dispatch({ type: FETCH_RAW_MATERIALS }), 5000);
    })
    .catch(error => handleError(RAW_MATERIAL, error, dispatch));
};

const rawActions = actionsFactory(RAW_MATERIAL);
const actions = {
  ...rawActions,
  ...thunkFactory(RAW_MATERIAL, '/raw_materials/'),
  importRawMaterials: importRawMaterialsMultiple
};
export { actions };

/** REDUCER -----------------------------------  **/

const initialState = {
  ids: [],
  models: {},
  loaded: false,
  loading: false,
  errorMessage: '',
  submitting: false
};


export default reducerFactory(RAW_MATERIAL, initialState, options);



/** SAGAS -------------------------------------  **/

/**
 * When we delete a Raw Material of type MIXTURE should fetch RawMaterials related
 * to maintain store raw material consistency
 *
 * @param payload
 * @returns {Generator<SimpleEffect<"PUT", PutEffectDescriptor<{payload: *, type: string}>>, void, *>}
 */
function* posDeleteRM({ payload }) {
  try {
    // It used to refetch each substance of the deleted mixture, one by one, to
    // refresh the `mixtures` array each of them carried. There is no such array
    // any more: the composition rows are their own slice, and the server
    // cascades them away with the raw material. So what has gone stale is that
    // slice, and one fetch replaces however many the mixture had members.
    //
    // It reads the same either way round: deleting a substance removes the rows
    // where it was a member, and this refetches those too.
    yield put({ type: FETCH_MIXTURES });
  } catch (error) {
    sagaErrorHandler(RAW_MATERIAL, error);
  }
}

function* watchPosDeleteRM() {
  yield takeLatest(DELETE + RAW_MATERIAL + FULFILLED, posDeleteRM);
}

// SAGAS
const sagas = [
  ...sagasFactory(RAW_MATERIAL, '/raw_materials/', { scopedByAccount: true }),
  fork(watchPosDeleteRM)
];

export { sagas };
